
$dependencyManager.addDependencyCallback('gsap', () => {
  const addressFieldsSelector = [
    '#checkout-section-billing input[name="billing_postcode"]',
    '#checkout-section-billing input[name="billing_address_1"]',
    '#checkout-section-billing input[name="billing_address_2"]',
    '#checkout-section-billing input[name="billing_city"]',
    '#checkout-section-billing select[name="billing_country"]',
    '#checkout-section-billing #billing_state',
    '#checkout-section-shipping input[name="shipping_postcode"]',
    '#checkout-section-shipping input[name="shipping_address_1"]',
    '#checkout-section-shipping input[name="shipping_address_2"]',
    '#checkout-section-shipping input[name="shipping_city"]',
    '#checkout-section-shipping select[name="shipping_country"]',
    '#checkout-section-shipping #shipping_state',
    '#checkout-section-shipping input[name="ship_to_different_address"]'
  ].join(', ');

  const lastValues = {};

  const handleAddressChange = window.$madUtil.debounce(function () {
    const $field = jQuery(this);
    const id = $field.attr('id');
    const val = $field.val().trim();

    if (lastValues[id] !== val) {
      lastValues[id] = val;
      jQuery(document.body).trigger('update_checkout', [{ update_shipping_method: true }]);
    }
  }, 1500);

  jQuery(document.body)
    .on('input change blur', addressFieldsSelector, handleAddressChange);

  jQuery(document.body).on(
    'change',
    'input[name^="shipping_method"], select.shipping_method',
    function () {
      console.log('[Shipping] Shipping method changed, triggering update_checkout');
      jQuery(document.body).trigger('update_checkout', [{ update_shipping_method: true }]);
    }
  );

  if (jQuery('#ship-to-different-address-checkbox').length) {
    const checkbox = jQuery('#ship-to-different-address-checkbox');

    checkbox.on('click', () => {
      if (checkbox.prop('checked')) {
        openShipping();
      } else {
        closeShipping();
      }
    });

    function openShipping() {
      let shippingHeight = 0;
      jQuery('#checkout-section-shipping')
        .children()
        .each(function () {
          shippingHeight += jQuery(this).outerHeight(true);
        });

      gsap.set('#checkout-section-shipping', { height: 0 });
      gsap.to('#checkout-section-shipping', {
        height: shippingHeight,
        duration: 0.4
      });

      const shippingOffset = jQuery('#checkout-section-shipping').offset().top;
      jQuery('html, body').animate({
        scrollTop: shippingOffset - 120
      }, 500);
    }

    function closeShipping() {
      gsap.to('#checkout-section-shipping', {
        height: 0,
        duration: 0.4
      });
    }
  }
});
